/**
 * Student Chat Page — שיחה כללית עם המדריך (/learn/chat)
 *
 * Thin wrapper over the generic track chat; see TrackChatPage. The greeting and
 * the AI persona come from the student track's PortalTrack record, so they are
 * admin-editable rather than hard-coded here.
 */

import TrackChatPage from './track/TrackChatPage'

export default function StudentChatPage() {
  return <TrackChatPage track="student" />
}
